import { render, staticRenderFns } from "./daily-office-notice.vue?vue&type=template&id=0cea027c&scoped=true"
import script from "./daily-office-notice.vue?vue&type=script&lang=js"
export * from "./daily-office-notice.vue?vue&type=script&lang=js"
import style0 from "./daily-office-notice.vue?vue&type=style&index=0&id=0cea027c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cea027c",
  null
  
)

export default component.exports